/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import * as apiModels from '@codegrade/api';
import { TenantsStore } from '@/store';
import { Search } from '@/utils/search';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class Tenant extends apiModels.ExtendedTenant {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static Searcher = new Search(['name', 'abbreviatedName']);
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get statistics() {
        return TenantsStore.getStatistics()(this);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    update(changed) {
        return new Tenant({ ...this, changed });
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class TenantStatistics {
    studentAmount;
    submmissionAmount;
    amountSubsLastWeek;
    courseAmounts;
    /**
     * @param studentAmount Map from end of academic year to the amount of students in that period.
     * @param submmissionAmount Map from end of academic year to the amount of submissions in that period.
     * @param amountSubsLastWeek The number of submission received in the last week.
     * @param courseAmounts The number of courses. Contains total and active courses.
     */
    constructor(studentAmount, submmissionAmount, amountSubsLastWeek, courseAmounts) {
        this.studentAmount = studentAmount;
        this.submmissionAmount = submmissionAmount;
        this.amountSubsLastWeek = amountSubsLastWeek;
        this.courseAmounts = courseAmounts;
    }
    /**
     * Constructs an instance of the tenant statistics object from api data.
     *
     * @param data The api data for the tenant statistics.
     * @returns The tenant statistics object constructed from api data.
     */
    static fromServerData(data) {
        return new TenantStatistics(new Map(Object.entries(data.studentAmounts).map(([key, value]) => [
            parseInt(key, 10),
            value,
        ])), new Map(Object.entries(data.submissionAmounts).map(([key, value]) => [
            parseInt(key, 10),
            value,
        ])), data.amountSubmissionsLastWeek, data.courseAmounts);
    }
}
